/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'auto-completed': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<g _fill="none" fill-rule="evenodd"><g transform="translate(.238 .556)"><circle pid="0" _fill="#0B1E07" cx="4.04" cy="4.04" r="4.04"/></g><path pid="1" _stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" d="M1.805 4.424l1.342 1.674 3.606-3.005"/></g>'
  }
})
